var G = Object.defineProperty;
var I = Object.getOwnPropertySymbols;
var J = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var O = (f, n, i) => n in f ? G(f, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : f[n] = i, R = (f, n) => {
  for (var i in n || (n = {}))
    J.call(n, i) && O(f, i, n[i]);
  if (I)
    for (var i of I(n))
      P.call(n, i) && O(f, i, n[i]);
  return f;
};
var F = (f, n, i) => new Promise((w, l) => {
  var N = (d) => {
    try {
      p(i.next(d));
    } catch (a) {
      l(a);
    }
  }, g = (d) => {
    try {
      p(i.throw(d));
    } catch (a) {
      l(a);
    }
  }, p = (d) => d.done ? w(d.value) : Promise.resolve(d.value).then(N, g);
  p((i = i.apply(f, n)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postRuleValidate as H } from "../../../../request/commoditycenter/form/ruleValidate/post.js";
import { postCodes as K } from "../../../../request/commoditycenter/commodity/classification/dictionary/rela/codes/post.js";
import Q from "../formMixin.js";
import { useLanguage as W } from "../../../../utils/useLanguage.js";
import { defineComponent as X, useTemplateRef as Y, watch as U, onMounted as Z, openBlock as $, createElementBlock as ee, createElementVNode as M, createVNode as o, withCtx as s, createTextVNode as x, Fragment as te } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as oe } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as k, unref as e } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import le from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ae from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import se from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import re from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import h from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import b from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import ie from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input-number/src/InputNumber.js";
import j from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import de from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import ne from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import z from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import { toDisplayString as y } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import B from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import ue from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const me = { style: { color: "#909399" } }, fe = { style: { display: "flex", "justify-content": "center", gap: "8px" } }, ze = /* @__PURE__ */ X({
  inheritAttrs: !1,
  __name: "daogui",
  props: {
    options: { default: () => ({}) },
    locale: { default: "zh-CN" }
  },
  emits: ["hide-dialog", "onSuccess"],
  setup(f, { expose: n, emit: i }) {
    const { i18n: w } = W(), { t: l } = w.global, N = Y("daogui"), g = f;
    U(
      () => g.locale,
      (u) => {
        w.global.locale.value = u || "zh-CN";
      },
      { immediate: !0 }
    );
    const p = i, {
      formSelect: d,
      // 混入中的响应式数据（与组件共享）
      formData: a,
      // 混入中的表单数据（替代组件自身定义）
      rules: E,
      // 混入中的校验规则（替代组件自身定义）
      allowEditFun: v,
      // 混入中的方法
      setDefault: q,
      // 混入中的方法
      setRequired: D
      // 混入中的方法
    } = Q();
    Object.assign(a, {
      productLength: 0,
      isStandard: "否",
      roomName: "",
      urgent: "否",
      deliveryMethod: "",
      installationMethod: ""
    });
    const S = oe(), c = k(!1), C = k(!0), _ = k(null), L = () => {
      p("hide-dialog");
    }, T = () => F(this, null, function* () {
      if (_.value)
        try {
          const u = yield _.value.validate();
          if (!u.warnings || u.warnings.length === 0) {
            const t = [
              {
                data: JSON.stringify(a),
                classificationCode: "FL_daogui"
              }
            ];
            c.value = !0;
            const m = yield H(t);
            c.value = !1, m.status ? (S.success(l("操作成功")), p("onSuccess", R({}, a)), p("hide-dialog")) : S.error(m.message || l("操作失败，请检查输入项"));
          }
        } catch (u) {
          c.value = !1, console.error("表单提交失败:", u);
        }
    }), V = () => F(this, null, function* () {
      const { commodityId: u } = g.options;
      if (u === void 0) {
        console.warn("commodityId 未定义，跳过请求");
        return;
      }
      const r = {
        commodityId: String(u),
        classificationCode: "FL_daogui",
        codes: []
      };
      try {
        c.value = !0;
        const t = yield K(r);
        if (c.value = !1, t) {
          d.value = t;
          const m = [
            { name: "installationMethod", message: l("请选择安装方式"), type: "" },
            { name: "deliveryMethod", message: l("请选择配送方式"), type: "" },
            { name: "urgent", message: l("请输入"), type: "" },
            { name: "roomName", message: l("请输入"), type: "" },
            { name: "productLength", message: l("请输入尺寸"), type: "number" }
          ];
          D(m, t), q(m, t);
        }
      } catch (t) {
        c.value = !1, console.error("获取分类数据失败:", t);
      }
    }), A = () => {
      Object.assign(a, {
        productLength: "0",
        isStandard: "否",
        roomName: "",
        urgent: "否",
        deliveryMethod: "",
        installationMethod: ""
      });
    };
    return U(
      () => g.options,
      (u) => {
        A(), u && Object.keys(a).forEach((r) => {
          if (Object.prototype.hasOwnProperty.call(a, r)) {
            const t = r;
            u[t] !== void 0 && (a[t] = u[t]);
          }
        }), V();
      },
      { immediate: !0, deep: !0 }
    ), Z(() => {
      V();
    }), n({
      daoguiForm: _,
      allowEditFun: v,
      // 暴露混入的方法给模板
      isShowDialog: C,
      formData: a
    }), (u, r) => ($(), ee(te, null, [
      M("div", {
        ref_key: "daogui",
        ref: N
      }, null, 512),
      o(e(ue), {
        bordered: "",
        show: C.value,
        "onUpdate:show": r[5] || (r[5] = (t) => C.value = t),
        "mask-closable": !1,
        to: N.value || "body"
      }, {
        default: s(() => [
          o(e(le), {
            class: "tw:!w-[50%] tw:!box-border tw:!text-left",
            title: e(l)("导轨"),
            bordered: !1,
            role: "dialog",
            closable: "",
            "header-class": "tw:!text-center",
            onClose: L
          }, {
            default: s(() => [
              o(e(ae), { show: c.value }, {
                default: s(() => [
                  o(e(se), {
                    model: e(a),
                    rules: e(E),
                    "label-placement": "left",
                    "label-width": "120px",
                    ref_key: "daoguiForm",
                    ref: _,
                    class: "tw:!text-left",
                    size: "small",
                    "require-mark-placement": "right-hanging"
                  }, {
                    default: s(() => [
                      o(e(re), null, {
                        default: s(() => [
                          o(e(h), { span: 24 }, {
                            default: s(() => [
                              o(e(b), {
                                label: e(l)("导轨尺寸"),
                                path: "productLength"
                              }, {
                                default: s(() => [
                                  o(e(ie), {
                                    "show-button": !1,
                                    disabled: !e(v)(e(d), "productLength"),
                                    value: e(a).productLength,
                                    "onUpdate:value": r[0] || (r[0] = (t) => e(a).productLength = t),
                                    min: 0,
                                    class: "tw:!w-[100%] tw:!text-center",
                                    placeholder: e(l)("请输入尺寸")
                                  }, {
                                    suffix: s(() => r[6] || (r[6] = [
                                      M("span", null, "mm", -1)
                                    ])),
                                    _: 1
                                  }, 8, ["disabled", "value", "placeholder"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          o(e(h), { span: 24 }, {
                            default: s(() => [
                              o(e(b), {
                                label: e(l)("安装方式"),
                                path: "installationMethod"
                              }, {
                                default: s(() => {
                                  var t;
                                  return [
                                    o(e(j), {
                                      value: e(a).installationMethod,
                                      "onUpdate:value": r[1] || (r[1] = (m) => e(a).installationMethod = m),
                                      placeholder: e(l)("请选择安装方式"),
                                      disabled: !e(v)(e(d), "installationMethod"),
                                      options: ((t = e(d).find((m) => m.code === "installationMethod")) == null ? void 0 : t.values) || [],
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      class: "tw:!w-[50%] tw:!text-left",
                                      to: !1
                                    }, null, 8, ["value", "placeholder", "disabled", "options"])
                                  ];
                                }),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          o(e(h), { span: 24 }, {
                            default: s(() => [
                              o(e(b), {
                                label: e(l)("房间名"),
                                path: "roomName"
                              }, {
                                default: s(() => [
                                  o(e(de), {
                                    disabled: !e(v)(e(d), "roomName"),
                                    value: e(a).roomName,
                                    "onUpdate:value": r[2] || (r[2] = (t) => e(a).roomName = t),
                                    placeholder: "",
                                    class: "tw:!text-left"
                                  }, null, 8, ["disabled", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          o(e(h), { span: 24 }, {
                            default: s(() => [
                              o(e(b), {
                                label: e(l)("配送方式"),
                                path: "deliveryMethod"
                              }, {
                                default: s(() => {
                                  var t;
                                  return [
                                    o(e(j), {
                                      value: e(a).deliveryMethod,
                                      "onUpdate:value": r[3] || (r[3] = (m) => e(a).deliveryMethod = m),
                                      disabled: !e(v)(e(d), "deliveryMethod"),
                                      options: ((t = e(d).find((m) => m.code === "deliveryMethod")) == null ? void 0 : t.values) || [],
                                      "label-field": "value",
                                      "value-field": "valueCode",
                                      "key-field": "valueCode",
                                      class: "tw:!w-[50%] tw:!text-left",
                                      to: !1
                                    }, null, 8, ["value", "disabled", "options"])
                                  ];
                                }),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }),
                          o(e(h), { span: 24 }, {
                            default: s(() => [
                              o(e(b), {
                                label: e(l)("是否加急"),
                                path: "urgent"
                              }, {
                                default: s(() => [
                                  o(e(ne), {
                                    disabled: !e(v)(e(d), "urgent"),
                                    value: e(a).urgent,
                                    "onUpdate:value": r[4] || (r[4] = (t) => e(a).urgent = t)
                                  }, {
                                    default: s(() => [
                                      o(e(z), { value: "是" }, {
                                        default: s(() => [
                                          x(y(e(l)("是")), 1)
                                        ]),
                                        _: 1
                                      }),
                                      o(e(z), { value: "否" }, {
                                        default: s(() => [
                                          x(y(e(l)("否")), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "value"]),
                                  M("span", me, " (" + y(e(l)("注：加急需收取加急费35元")) + ")", 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      M("div", fe, [
                        o(e(B), {
                          onClick: L,
                          size: "small"
                        }, {
                          default: s(() => [
                            x(y(e(l)("取消")), 1)
                          ]),
                          _: 1
                        }),
                        o(e(B), {
                          type: "primary",
                          onClick: T,
                          size: "small"
                        }, {
                          default: s(() => [
                            x(y(e(l)("确定")), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ze as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/daogui/daogui.vue.js
// module id = 1254
// module chunks = 67